module.exports = __webpack_public_path__ + "img/service5.2290141c.png";